import { Link } from 'react-router-dom'

export function AccountInactivePage() {
	return (
		<div className="min-h-screen flex items-center justify-center bg-muted">
			<div className="text-center max-w-md">
				<div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-amber-100">
					<svg
						className="h-8 w-8 text-amber-600"
						fill="none"
						viewBox="0 0 24 24"
						strokeWidth="1.5"
						stroke="currentColor"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
						/>
					</svg>
				</div>
				<h1 className="text-2xl font-bold text-foreground">Account Pending Activation</h1>
				<p className="mt-3 text-muted-foreground">Your account is pending activation. Contact an administrator.</p>
				<Link
					to="/login"
					className="mt-6 inline-block px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
				>
					Back to Login
				</Link>
			</div>
		</div>
	)
}
